import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

const SYNC_NOTE_ICON_SIZE = "18px";
const RADIO_SIZE = "20px";
const SEARCH_BAR_HEIGHT = "46px";

export const useExistingTeamPickerStyles = makeStyles({
  teamPicker: {
    marginTop: designTokens.spacing[4],
  },
  teamListCard: {
    border: `1px solid ${designTokens.neutral[200]}`,
    borderRadius: designTokens.borderRadius.lg,
    overflow: "hidden",
    backgroundColor: designTokens.neutral.white,
  },
  searchBar: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
    height: SEARCH_BAR_HEIGHT,
    paddingLeft: designTokens.spacing[4],
    paddingRight: designTokens.spacing[4],
    backgroundColor: designTokens.neutral[50],
    borderBottom: `1px solid ${designTokens.neutral[100]}`,
  },
  searchInput: {
    flex: 1,
    minWidth: 0,
    backgroundColor: designTokens.neutral[50],
    ":hover": {
      backgroundColor: designTokens.neutral[50],
    },
    ":focus-within": {
      backgroundColor: designTokens.neutral[50],
    },
  },
  pagination: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: designTokens.spacing[2],
    padding: `${designTokens.spacing[1]} ${designTokens.spacing[4]}`,
    backgroundColor: designTokens.neutral[50],
    borderTop: `1px solid ${designTokens.neutral[100]}`,
  },
  paginationLabel: {
    fontSize: designTokens.fontSize.xs,
    color: designTokens.neutral[500],
  },
  paginationActions: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[1],
  },
  teamRow: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[3],
    width: "100%",
    padding: `${designTokens.spacing[3]} ${designTokens.spacing[4]}`,
    textAlign: "left" as const,
    border: "none",
    borderBottom: `1px solid ${designTokens.neutral[100]}`,
    backgroundColor: designTokens.neutral.white,
    cursor: "pointer",
    ":hover": {
      backgroundColor: designTokens.neutral[50],
    },
    ":focus-visible": {
      outline: `2px solid ${designTokens.accent[500]}`,
      outlineOffset: "-2px",
    },
  },
  teamRowSelected: {
    backgroundColor: designTokens.accent[50],
    ":hover": {
      backgroundColor: designTokens.accent[50],
    },
  },
  teamRowDisabled: {
    opacity: 0.55,
    cursor: "not-allowed",
    ":hover": {
      backgroundColor: designTokens.neutral.white,
    },
  },
  radioIndicator: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    width: RADIO_SIZE,
    height: RADIO_SIZE,
    borderRadius: designTokens.borderRadius.full,
    border: `1.5px solid ${designTokens.neutral[300]}`,
    backgroundColor: designTokens.neutral.white,
    color: designTokens.neutral.white,
    fontSize: designTokens.fontSize.xs,
  },
  radioIndicatorSelected: {
    border: `1.5px solid ${designTokens.accent[500]}`,
    backgroundColor: designTokens.accent[500],
  },
  suggestedBadge: {
    flexShrink: 0,
    fontSize: designTokens.fontSize.xxs,
    fontWeight: designTokens.fontWeight.bold,
    color: designTokens.accent[700],
    backgroundColor: designTokens.accent[50],
    padding: `1px ${designTokens.spacing[2]}`,
    borderRadius: designTokens.borderRadius.full,
  },
  connectedNote: {
    minWidth: 0,
    maxWidth: "40%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.semibold,
    color: designTokens.neutral[500],
  },
  emptyState: {
    padding: designTokens.spacing[6],
    textAlign: "center" as const,
    fontSize: designTokens.fontSize["2xs"],
    color: designTokens.neutral[500],
  },
  syncNote: {
    display: "flex",
    alignItems: "flex-start",
    gap: designTokens.spacing[3],
    marginTop: designTokens.spacing[3],
    padding: designTokens.spacing[3],
    borderRadius: designTokens.borderRadius.lg,
    backgroundColor: designTokens.neutral[50],
    color: designTokens.accent[500],
  },
  syncNoteIcon: {
    flexShrink: 0,
    width: SYNC_NOTE_ICON_SIZE,
    height: SYNC_NOTE_ICON_SIZE,
  },
  noteText: {
    margin: 0,
    fontSize: designTokens.fontSize["2xs"],
    color: designTokens.neutral[500],
    lineHeight: designTokens.lineHeight.relaxed,
  },
});
